import { useKeycloak } from "~/components/authorization";
import { useDashboardStaffProvider } from "~/components/pages/authorized/dashboard_staff/DashboardStaffProvider";
import { useMessages } from "~/providers/MessagesProvider";

export const useProfileLink = () => {
  const keycloak = useKeycloak();

  const { selectedParticipant } = useDashboardStaffProvider();
  const { totalUnread } = useMessages();

  const onProfileNavigate = () => {
    const accountUrl = new URL(keycloak.createAccountUrl());

    if (selectedParticipant) {
      accountUrl.searchParams.set("participantName", `${selectedParticipant.firstName} ${selectedParticipant.lastName}`);
      accountUrl.searchParams.set("participantId", selectedParticipant.participantId);
    }

    accountUrl.searchParams.set("totalUnread", (totalUnread ?? 0).toString());

    window.location.href = accountUrl.toString();
  };

  return { onProfileNavigate };
};
